import RichText from "@modules/products/components/product-page-sections/rich-text"
import type { StoreRichTextDocument } from "@modules/products/types"

export default function SafeRichText({
  document,
  className,
  headingIdPrefix,
}: {
  document?: StoreRichTextDocument | null
  className?: string
  headingIdPrefix?: string
}) {
  return (
    <RichText
      document={document}
      className={className}
      headingIdPrefix={headingIdPrefix}
    />
  )
}
